import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: false,
    teams: [],
    roles: [],
    holidays: [],
    setting: null
  };

  const slice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
      // START LOADING
      startLoading(state) {
        state.isLoading = true;
      },
      endLoading(state) {
        state.isLoading = false;
      },
      // HAS ERROR
      hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload;
      },
      getTeams(state, action) {
        state.isLoading = false;
        state.teams = action.payload;
      },
      getHolidays(state, action) {
        state.isLoading = false;
        state.holidays = action.payload;
      },
      getRoles(state, action) {
        state.isLoading = false;
        state.roles = action.payload;
      },
      getUsers(state, action) {
        state.isLoading = false;
        state.users = action.payload;
      },
      getSetting(state, action) {
        state.isLoading = false;
        state.setting = action.payload;
      },
    }
  });
  
  export function getTeams() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/iapi/admin/teams');
        dispatch(slice.actions.getTeams(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  };

  export function getHolidays() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/iapi/admin/settings/holidays');
        dispatch(slice.actions.getHolidays(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  };

  export function getUsers() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/iapi/admin/users');
        dispatch(slice.actions.getUsers(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  };

  export function getRoles() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('/iapi/roles');
        dispatch(slice.actions.getRoles(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  };
  export function getSetting() {
    return async (dispatch) => {
      try {
        const response = await axios.get('/iapi/admin/settings');
        dispatch(slice.actions.getSetting(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  };
  export function saveUser(data) {
    return async (dispatch) => {
      // dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/users', data);
        // dispatch(slice.actions.endLoading());
        return response.data;
      } catch (error) {
        dispatch(slice.actions.endLoading());
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }
  export function saveSetting(data) {
    return async (dispatch) => {
      // dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/settings', data);
        // dispatch(slice.actions.endLoading());
        return response.data;
      } catch (error) {
        dispatch(slice.actions.endLoading());
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }
  export function saveHoliday(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/settings/holidays', data);
        // dispatch(slice.actions.endLoading());
        return response.data;
      } catch (error) {
        dispatch(slice.actions.endLoading());
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function deleteHoliday(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.delete('/iapi/admin/settings/holidays/'+data.id);
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function deleteUser(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.delete('/iapi/admin/users/' + data.id);
        // dispatch(slice.actions.deleteClientCadences(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function loginAsUser(id) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/login_as_user', {id: id});
        // dispatch(slice.actions.deleteClientCadences(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function sendPasswordReset(id) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/reset_password', {id: id});
        // dispatch(slice.actions.deleteClientCadences(response.data));
        dispatch(slice.actions.endLoading());
        return response.data;
      } catch (error) {
        dispatch(slice.actions.endLoading());
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function updatePassword(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/update_password', data);
        // dispatch(slice.actions.deleteClientCadences(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }

  export function updateSelfPassword(data) {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.post('/iapi/admin/update_self_password', data);
        // dispatch(slice.actions.deleteClientCadences(response.data));
        return response.data;
      } catch (error) {
        dispatch(slice.actions.hasError(error));
        return false
      }
    };
  }
  
  // Reducer
  export default slice.reducer;
  // Actions
  export const { onToggleFollow } = slice.actions;